export default {
  getWorkspaceData (state) {
    return state.workspaceArray;
  },
};